
import React, { useState, useEffect } from 'react';
import CVAnalysisPanel from './CVAnalysisPanel';
import InterviewPanel from './InterviewPanel';
import InterviewResults from './InterviewResults';
import Card from '../common/Card';
import { useAppContext } from '../../hooks/useAppContext';

const AgentTab = () => {
  const { jobs, loadJobs } = useAppContext();
  const [selectedJobId, setSelectedJobId] = useState('');
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [interviewResultsKey, setInterviewResultsKey] = useState(0);

  // Refresh jobs when tab is opened
  useEffect(() => {
    loadJobs();
  }, [loadJobs]);

  // Filter to only show Open/active jobs
  const openJobs = jobs.filter(job => job.status === 'Open');

  // Handler for when interview link is generated - triggers InterviewResults refresh
  const handleLinkGenerated = () => {
    setInterviewResultsKey(prev => prev + 1);
    setShowResults(true);
  };

  return (
    <div className="agent-tab">
      <Card>
        <h2 className="card-title">🤖 AI Agent - CV Screening & Interview</h2>
        <div className="form-group">
          <label className="form-label">Select Job Position to Screen *</label>
          <select 
            className="form-input"
            value={selectedJobId}
            onChange={(e) => {
              setSelectedJobId(e.target.value);
              setSelectedApplicant(null);
              setShowResults(false);
            }}
          >
            <option value="">-- Select a job position to start screening --</option>
            {openJobs.length === 0 ? (
              <option value="" disabled>No open positions available for screening</option>
            ) : (
              openJobs.map(job => {
                const candidateCount = job.cvCount || job.totalApplications || 0;
                return (
                  <option key={job.id} value={job.id}>
                    {job.title} ({candidateCount} {candidateCount === 1 ? 'candidate' : 'candidates'})
                  </option>
                );
              })
            )}
          </select>
        </div>
      </Card>

      {selectedJobId && (
        <>
          <div className="agent-panels-grid">
            <Card>
              <h3 className="card-title">📊 CV Analysis & Scoring</h3>
              <CVAnalysisPanel 
                jobId={selectedJobId}
                onSelectApplicant={(applicant) => {
                  setSelectedApplicant(applicant);
                  setShowResults(false);
                  setInterviewResultsKey(prev => prev + 1);
                }}
                selectedApplicant={selectedApplicant}
              />
            </Card>

            <Card>
              <h3 className="card-title">💬 Interview Screening</h3>
              <InterviewPanel 
                applicant={selectedApplicant}
                jobId={selectedJobId}
                jobMongoId={jobs.find(j => j.id === selectedJobId)?._id}
                onInterviewComplete={() => setShowResults(true)}
                onLinkGenerated={handleLinkGenerated}
              />
            </Card>
          </div>

          {selectedApplicant && (
            <InterviewResults 
              key={interviewResultsKey}
              applicant={selectedApplicant} 
              jobId={selectedJobId} 
            />
          )}
        </>
      )}
    </div>
  );
};

export default AgentTab;
